<template>
  <a-result :isSuccess="true" :content="false" :title="email">
    <template #extra>
      <a-button size="large" type="primary" @click="goHomeHandle">前往登录页</a-button>
    </template>
  </a-result>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import cookie from 'js-cookie'
export default {
  name: 'RegisterResult',
  data() {
    return {
      form: {},
    }
  },
  computed: {
    email() {
      const v = (this.form && this.form.username) || 'xxx'
      return `你的账户：${v} 注册成功`
    },
  },
  created() {
    this.form = this.$route.params
  },
  methods: {
    goHomeHandle() {
      cookie.remove(ACCESS_TOKEN)
      this.$router.push({ name: 'login' })
    },
  },
}
</script>

<style scoped>
</style>
